import React, { memo } from 'react';
import PropTypes from 'prop-types';

import styles from './FormFieldWithLine.module.scss';

function FormFieldWithLine({
  children, label, isRequired, subtitle,
}) {
  return (
    <div className={styles.Component}>
      <div>
        <label className={`${isRequired ? 'require' : ''}`} htmlFor={children.props.id}>
          {label}
        </label>

        {subtitle && (
        <div className="Subtitle">
          {subtitle}
        </div>
        )}

      </div>

      { children }
    </div>
  );
}

FormFieldWithLine.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  subtitle: PropTypes.string,
};

FormFieldWithLine.defaultProps = {
  label: '',
  isRequired: false,
  subtitle: '',
};

export default memo(FormFieldWithLine);
